<template>
  <div class="px-2 my-4">
    <h1 class="text-4xl font-extrabold tracking-tight text-gray-900">Historique</h1>
  </div>

  <Loading v-if="loading" />
  <ChallengeList v-else :challenges="challenges" :storeId="this.selectedStoreId" />
</template>

<script>
import { mapState } from "vuex";
import StoreService from "@/api/services/store";
import { Loading } from "@estaly/ui";
import ChallengeList from "@/components/challenge/ChallengeList.vue";

import { toCamelCase } from "@estaly/ui/src/utils/data_formatter";

export default {
  components: { ChallengeList, Loading },

  data() {
    return {
      loading: true,
      challenges: [],
    };
  },

  computed: {
    ...mapState("store", ["selectedStoreId"]),
  },

  async mounted() {
    if (this.selectedStoreId) {
      await this.retrieveChallenges();
    }
  },

  methods: {
    async retrieveChallenges() {
      this.loading = true;
      const response = await StoreService.getChallenges(this.selectedStoreId);
      if (response?.success) {
        const data = toCamelCase(response.data);
        this.challenges = data.challenges;
      }
      this.loading = false;
    },
  },
};
</script>
